import React, { useState } from 'react'

import styled from 'styled-components'

import RadioInputs from 'components/RadioInputs'
import Textarea from 'components/Textarea'
import Select, { SelectOption } from 'components/Select'
import Modal from 'components/Modal'
import { Button } from '@nexiahome/ui-common/components/primitives/buttons'

import { color } from 'styles/colors'
import { ButtonContainer } from 'styles/shared'

import Api from 'services/api'
import Apptentive from 'helpers/apptentive'

type Props = {
  deviceId: string
  onCloseCallback: () => void
}

const Durations: SelectOption[] = [
  { value: 1, name: '1 hour' },
  { value: 4, name: '4 hours' },
  { value: 12, name: '12 hours' },
  { value: 24, name: '24 hours' },
  { value: 48, name: '48 hours' },
  { value: 72, name: '72 hours' }
]

const Inputs = [
  { value: 0, backgroundColor: color('paneBackground'), label: 'Hello, as part of our ongoing service, we would like to make sure your system is working properly. Please allow us a few minutes to give it a remote tune-up.' },
  { value: 1, backgroundColor: color('paneBackground'), label: 'We have detected a configuration problem with your system. In order to help resolve the issue(s), we would like to troubleshoot your system from our office.' },
  { value: 2, backgroundColor: color('paneBackground'), label: 'Hello, in preparation for your service appointment, we would like to update your configurations to ensure we address issue(s) in an efficient manner.' }
]

const RequestRemoteAccessModal = ({ deviceId, onCloseCallback }: Props) => {
  const [message, setMessage] = useState(Inputs[0].label)
  const [selectedInputMessage, setSelectedInputMessage] = useState(0)
  const [selectedDurationValue, setSelectedDurationValue] = useState(Durations[0].value)
  const [isLoading, setIsLoading] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)

  const onChangeSelectedInput = (value) => {
    setSelectedInputMessage(Number(value))
    setMessage(Inputs[value].label)
  }

  const onSendClick = () => {
    setIsLoading(true)
    setShowSpinner(true)
    Api.RemoteConfig.requestAccess(deviceId, { message, duration: Number(selectedDurationValue) * 60 })
      .then(() => {
        Apptentive.sendEvent('request_remote_access_submitted')

        onCloseCallback()
      })
      .finally(() => {
        setIsLoading(false)
        setShowSpinner(false)
      })
  }

  return (
    <Modal variant="sm" isDisplayed title="Request Remote Access" closeCallback={onCloseCallback}>
      <S.RadioInputs selectedValue={selectedInputMessage} radioOptions={Inputs} onChange={(event) => onChangeSelectedInput(event.target.value)} />
      <S.Textarea label="Message" value={message} onChange={(event) => setMessage(event.target.value)} maxLength={250} rows={1} />
      <S.Select label="Duration" selectOptions={[Durations]} value={selectedDurationValue} onChange={(event) => setSelectedDurationValue(event.target.value)} />

      <ButtonContainer noBorder>
        <Button decoration="secondary" styles={{ button: { marginRight: 15 } }} text="Cancel" onPress={onCloseCallback} />
        <Button decoration="positive" enabled={!isLoading} text="Send" onPress={onSendClick} showSpinner={showSpinner} />
      </ButtonContainer>
    </Modal>
  )
}

export default RequestRemoteAccessModal

const S = {
  RadioInputs: styled(RadioInputs)`
    flex-direction: column;

    & > :nth-child(n+1) {
      border-radius: 5px;
      border: 1px solid ${color('border')};
      padding: 5px 10px 5px 10px;
      margin: 5px 0px 5px 0px;

      & > label:first-of-type {
        border: none;
        text-align: left;
        font-weight: inherit;
        text-transform: inherit;
        font-size: inherit;
        margin: 0px;
        padding: 0px 0px 0px 10px;
      }
    }
  `,
  Textarea: styled(Textarea)`
    height: 100px;

  & > textarea {
    max-height: 100px;
  }
  `,
  Select: styled(Select)`
   padding-top: 12px;
  `
}
